import Icon from "../Icon";
import { ToggleButton } from "./ToggleButton";
import "../../styles/buttons/anchorButton.css";
import { ExpandingTooltipReturn } from "../hooks/useAdvancedTooltip";

export { AnchorButton };

type Props = {
  anchor: boolean;
  reversed: boolean;
  onAnchorChange?: () => void;
  onAnchorReverseChange?: (reversed: boolean) => void;
  tProps?: ExpandingTooltipReturn["triggerProps"];
};

const AnchorButton = ({
  anchor,
  reversed,
  onAnchorChange,
  onAnchorReverseChange,
  tProps,
}: Props) => {
  return (
    <ToggleButton
      active={anchor}
      tProps={tProps}
      className={"anchorButton " + (anchor ? "" : "white")}
      onClick={() => {
        if (!anchor) {
          onAnchorChange && onAnchorChange();
        } else {
          onAnchorReverseChange && onAnchorReverseChange(!reversed);
        }
      }}
    >
      <Icon
        altText={""}
        icon={"anchor"}
        className={anchor ? (reversed ? "flip" : "") : "inverse"}
      />
    </ToggleButton>
  );
};
